export default "__VITE_ASSET__BgyhApZO__"